export var ColorPickerGridCellStyles = function ColorPickerGridCellStyles(props) {
  var theme = props.theme,
      selected = props.selected,
      isWhite = props.isWhite;
  var buttonBorderHovered = theme.palette.neutralLighter;
  var buttonBorderChecked = theme.palette.neutralLight;
  var buttonBorderIsWhite = theme.palette.neutralTertiary;
  return {
    colorCell: [selected && {
      borderColor: buttonBorderChecked
    }, !selected && {
      selectors: (_a = {}, _a['&:hover, &:active, &:focus'] = {
        borderColor: buttonBorderHovered
      }, _a)
    }, isWhite && !selected && {
      backgroundColor: buttonBorderIsWhite
    }]
  };

  var _a;
};